import styled, { css } from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;
export const FormBody = styled.div`
  max-height: 60vh;
  padding: 0 1.375rem;
  overflow-y: auto;
`;
export const OptionsWrapper = styled.div`
  padding: 1.375rem;
`;
export const FlexRow = styled.div`
  display: flex;
  align-items: center;
  > div {
    margin-right: 1rem;
  }
`;
export const SectionContainer = styled.section`
  width: 100%;
`;
export const ReportWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  font-weight: normal;
  margin-top: 10px;
`;
export const ReportTitleText = styled.h2`
  color: #ff5200;
  font-size: 16px;
  font-family: lato;
  text-transform: initial;
  margin-bottom: 10px;
  line-height: 1;
  margin-top: 3px;
  font-weight: bold !important;
`;
export const WrapperStatus = styled.div`
  justify-self: auto;
`;
export const WrapperStatusDate = styled.div`
  text-align: right;
`;
export const ReportWrapperSummary = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  font-weight: normal;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #979797;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  padding: 10px;
  margin-top: 15px;
`;
export const WrapperSubTitle = styled.div`
  justify-self: auto;
  color: #15aee5;
  font-weight: bold !important;
`;
export const ButtonAttendeesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1px;
  width: 88%;
`;
export const ButtonContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1px;
`;
export const ButtonData = styled(BaseButton)`
  background: #15aee5;
  border: 1px solid #15aee5;
  font-weight: normal;
  width: auto;
  margin-right: 5px;
  font-size: 14px;
  font-family: lato;
`;
export const ReportTitleValue = styled.div`
  color: #767676;
  margin: 0;
  line-height: 1;
  font-size: 16px;
  padding-left: 10px;
  margin-top: 5px;
  font-size: 14px;
  font-family: lato;
  font-style: normal;
`;

export const DocumentRow = styled.div`
  padding-left: 1rem;
  margin-bottom: 0.2rem;
`;

export const DocumentInfo = styled.div`
  display: grid;
  text-color: #084987 !important;
  gap: 1.25rem;
  margin: 0;
`;

export const DocumentWrppaer = styled.div`
  margin-bottom: 10px;
`;

export const DocumentName = styled.a`
  position: relative;
  font-size: 14px;
  line-height: 16px;
  color: #1bace4 !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none !important;
  cursor: pointer;
  text-transform: initial;
  margin: 0;
`;
